//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      currentValue: [],
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted () {
    //已答的题挂上答案
    if (this.question.v_answer) {
      //选中选项
      this.currentValue = this.question.v_answer.currentValue
    }
  },
  methods: {
    cancel () {
      this.$emit('popup-close')
    },
    ok () {
      console.log(this.currentValue);
      this.$emit('onChoose', this.currentValue)
      this.$emit('popup-close')
    }
  }
}
